import { __extends } from "tslib";
import { addClass, getShadowElement, removeClass } from '@tyler-components-web/core';
import { BACKDROP_CONSTANTS } from '../backdrop';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { DRAWER_CONSTANTS } from './drawer-constants';
var DrawerAdapter = /** @class */ (function (_super) {
    __extends(DrawerAdapter, _super);
    function DrawerAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._drawerElement = getShadowElement(_this._component, DRAWER_CONSTANTS.selectors.DRAWER);
        _this._rootElement = getShadowElement(_this._component, DRAWER_CONSTANTS.selectors.ROOT);
        _this._shadowRoot = _this._component.shadowRoot;
        return _this;
    }
    DrawerAdapter.prototype.setDirection = function (direction) {
        switch (direction) {
            case 'left':
                this._drawerElement.classList.remove(DRAWER_CONSTANTS.classes.RIGHT);
                this._drawerElement.classList.add(DRAWER_CONSTANTS.classes.LEFT);
                break;
            case 'right':
                this._drawerElement.classList.remove(DRAWER_CONSTANTS.classes.LEFT);
                this._drawerElement.classList.add(DRAWER_CONSTANTS.classes.RIGHT);
                break;
        }
    };
    DrawerAdapter.prototype.removeDrawerClass = function (className) {
        removeClass(className, this._drawerElement);
    };
    DrawerAdapter.prototype.setDrawerClass = function (className) {
        addClass(className, this._drawerElement);
    };
    DrawerAdapter.prototype.setBackdrop = function (isOpen, listener) {
        if (isOpen) {
            if (!this._backdropElement) {
                this._backdropElement = document.createElement(BACKDROP_CONSTANTS.elementName);
                if (listener) {
                    this._backdropElement.addEventListener(BACKDROP_CONSTANTS.events.BACKDROP_CLICK, listener);
                }
            }
            this._shadowRoot.insertBefore(this._backdropElement, this._rootElement);
        }
        else if (this._backdropElement) {
            return this._backdropElement.fadeOut();
        }
        return Promise.resolve();
    };
    DrawerAdapter.prototype.removeBackdrop = function () {
        if (this._backdropElement && this._backdropElement.isConnected) {
            this._shadowRoot.removeChild(this._backdropElement);
        }
    };
    DrawerAdapter.prototype.listenTransitionComplete = function (listener) {
        var _this = this;
        if (this._activeTransitionListener) {
            this._drawerElement.removeEventListener('transitionend', this._activeTransitionListener);
        }
        this._activeTransitionListener = function (evt) {
            if (evt.propertyName === 'width') {
                if (_this._activeTransitionListener) {
                    _this._drawerElement.removeEventListener('transitionend', _this._activeTransitionListener);
                    _this._activeTransitionListener = undefined;
                }
                listener();
            }
        };
        this._drawerElement.addEventListener('transitionend', this._activeTransitionListener);
    };
    return DrawerAdapter;
}(BaseAdapter));
export { DrawerAdapter };
